// CRITICAL!! : This file should never be checked into master without the file in this state (exporting a boolean isActive property set as false)...EK
export let isActive = false;

//WARNING: These are included here to prevent webpack warnings when not running under Cordova
export const views = null;
export const valueStatuses = null;
export const tags = null;
export const tagLinks = null;
export const styles = null;
export const securityGroups = null;
export const securityGroupLookups = null;
export const securities = null;
export const recordTypes = null;
export const categories = null;
export const properties = null;
export const packages = null;
export const extensions = null;
